var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_c('h4', [_vm._v("SAML")]), _c('div', {
    staticClass: "buttons"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-plus",
      "round": "",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.generateSAMLMetadata
    }
  }, [_vm._v("Generate SAML metadata")])], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }